const differences = [
  {
    icon: 'ri-lightbulb-line',
    title: '懂品牌經營，不只懂裝潢',
    desc: '我們從品牌定位出發，思考空間如何傳遞品牌價值，協助業主打造具有識別度與競爭力的商業環境，而非單純的美化工程。',
  },
  {
    icon: 'ri-route-line',
    title: '重視消費體驗與空間動線',
    desc: '消費動線、停留設計、購買引導——我們將消費者行為研究融入空間規劃，讓空間本身成為品牌的銷售工具。',
  },
  {
    icon: 'ri-scales-3-line',
    title: '兼顧美感、實用性與預算',
    desc: '高質感不等於高預算。我們擅長在合理預算內，選用最具性價比的材料與工法，達到理想的品牌氛圍與耐用度。',
  },
  {
    icon: 'ri-git-merge-line',
    title: '設計與工程整合落地',
    desc: '從設計到施工一條龍服務，設計師與工程團隊緊密協作，確保設計意圖完整落實，杜絕「設計好看但施工走樣」的問題。',
  },
];

export default function DifferenceSection() {
  return (
    <section className="py-24 md:py-32 bg-[#f4f2ef]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-[#b8956a] text-sm font-medium tracking-[0.2em] uppercase mb-4">Why Us</p>
          <h2
            className="font-bold text-[#1a1a1a] leading-[1.35] mb-4"
            style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)' }}
          >
            我們與一般室內設計公司的差異
          </h2>
          <p className="text-[#5a5a5a] max-w-xl mx-auto" style={{ fontSize: '1.1875rem' }}>
            心旅商研的服務核心，是以「商業思維」驅動「空間設計」，
            而非只是單純的美感呈現。
          </p>
        </div>

        {/* Difference Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {differences.map((d, i) => (
            <div key={i} className="bg-[#fafaf8] rounded-2xl p-10 flex gap-6">
              <div className="w-14 h-14 flex items-center justify-center bg-[#b8956a]/10 rounded-2xl flex-shrink-0">
                <i className={`${d.icon} text-[#b8956a] text-2xl`}></i>
              </div>
              <div>
                <h3
                  className="font-semibold text-[#1a1a1a] mb-3 leading-[1.45]"
                  style={{ fontSize: '1.125rem' }}
                >
                  {d.title}
                </h3>
                <p className="text-[#5a5a5a] leading-relaxed" style={{ fontSize: '1rem' }}>
                  {d.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
